module.exports = __webpack_public_path__ + "static/media/01 - BD.b951fce6.wav";